<template>
    <Layout sub="businesses" main="Businesses">
        <div class="px-4 sm:px-6 lg:px-8">
            <div class="sm:flex sm:items-center">
                <div class="sm:flex-auto">
                    <h1 class="text-xl font-semibold text-gray-900">Businesses</h1>
                    <p class="mt-2 text-sm text-gray-700">A list of businesses</p>
                </div>
            </div>
            <div class="sm:flex sm:items-center bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mt-10">
                    <div align="left" class="px-4 sm:px-4 lg:px-0 mt-2 ml-5 text-sm" v-show="filters.status">

                        Status is <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('status')" /></div>
                        <select
                            v-model="fields.status"
                            @change="handleFilter"
                            id="searchFieldStatus"
                            name="searchFieldStatus"
                            class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">All Statuses</option>
                            <option value="true">Active</option>
                            <option value="false">Disabled</option>
                        </select>
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 text-sm" v-show="filters.publish">
                        Publish is <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('publish')" /></div>
                        <select
                            v-model="fields.publish"
                            @change="handleFilter"
                            id="searchFieldVisibility"
                            name="searchFieldVisibility"
                            class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">All Visibilities</option>
                            <option value="true">Public</option>
                            <option value="false">Private</option>
                        </select>
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 text-sm" v-show="filters.featured">
                        Featured? <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('featured')" /></div>
                        <select
                            v-model="fields.featured"
                            @change="handleFilter"
                            id="searchFieldFeatured"
                            name="searchFieldFeatured"
                            class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">Yes/No</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 text-sm" v-show="filters.verified">
                        Verified? <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('verified')" /></div>
                        <select
                            v-model="fields.verified"
                            @change="handleFilter"
                            id="searchFieldVerified"
                            name="searchFieldVerified"
                            class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">Yes/No</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 text-sm" v-show="filters.category">
                        Category is <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('category', )" /></div>
                        <select
                            v-model="fields.category"
                            @change="handleFilter"
                            id="searchFieldCategory"
                            name="searchFieldCategory"
                            class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">All</option>
                            <option v-for="category in props.categories" v-bind:value="category.id">
                                {{ category.name }}
                            </option>
                        </select>
                    </div>
                    <div align="left" class="px-4 sm:px-4 lg:px-0 ml-5 mb-2 text-sm" v-show="filters.name">
                        Name contains <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('name')" /></div>
                        <input
                            v-model="fields.name"
                            @change="handleFilter"
                            required
                            name="searchFieldName"
                            id="searchFieldName"
                            class="h-9 px-2 w-full rounded text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 dark:border-gray-700 dark:focus:border-indigo-600 focus:outline-none focus:border focus:border-indigo-700 border-gray-300 border"
                            type="text"
                        />
                    </div>
                    <div align="left" class="px-4 sm:px-4 lg:px-0 ml-5 mb-2 text-sm" v-show="filters.email">
                        Email contains <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('email')" /></div>
                        <input
                            v-model="fields.email"
                            @change="handleFilter"
                            required
                            name="searchFieldEmail"
                            id="searchFieldEmail"
                            class="h-9 px-2 w-full rounded text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 dark:border-gray-700 dark:focus:border-indigo-600 focus:outline-none focus:border focus:border-indigo-700 border-gray-300 border"
                            type="text"
                        />
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 mb-4 text-sm" v-show="filters.city">
                        City is <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('city')" /></div>
                        <SimpleTypeahead
                            id="typeahead_idCity"
                            v-model="fields.city"
                            @change="handleFilter"
                            placeholder=""
                            class="h-9 px-2 w-full rounded text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 dark:border-gray-700 dark:focus:border-indigo-600 focus:outline-none focus:border focus:border-indigo-700 border-gray-300 border"
                            :items="cities"
                            :minInputLength="1"
                            :itemProjection="(item) => item"
                        >
                        </SimpleTypeahead>
                    </div>

                    <div align="left" class="px-4 sm:px-4 lg:px-8 mt-2 ml-5 mb-4 text-sm" v-show="filters.region">
                        Region is <div align="right" class="mt-[-12px]"><XCircleIcon class="h-4 w-4" aria-hidden="true" @click="removeFilter('region')" /></div>
                        <SimpleTypeahead
                            id="typeahead_idRegion"
                            v-model="fields.region"
                            @change="handleFilter"
                            placeholder=""
                            class="h-9 px-2 w-full rounded text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 dark:border-gray-700 dark:focus:border-indigo-600 focus:outline-none focus:border focus:border-indigo-700 border-gray-300 border"
                            :items="regions"
                            :minInputLength="1"
                            :maxInputLength="2"
                            :itemProjection="(item) => item"
                        >
                        </SimpleTypeahead>
                    </div>

                    <div align="right" class="px-4 sm:px-4 lg:px-0 mt-5 ml-5 mr-5">
                        <select
                            v-model="addFilterSelect"
                            id="filterOptions"
                            name="filterOptions"
                            class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        >
                            <option value="" selected="selected">Add filters</option>
                            <option value="category">Category</option>
                            <option value="status">Status</option>
                            <option value="publish">Publish</option>
                            <option value="featured">Featured</option>
                            <option value="verified">Verified</option>
                            <option value="name">Name</option>
                            <option value="email">E-mail</option>
                            <option value="city">City</option>
                            <option value="region">Region</option>
                        </select>
                    </div>

<!--                <div align="left" class="sm:mt-0 sm:ml-10 sm:flex-none mt-0" style='margin-top: 10px !important;'>-->
<!--                    <button-->
<!--                        @click="resetAllFilters"-->
<!--                        type="button"-->
<!--                        class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"-->
<!--                    >-->
<!--                        Reset Filters-->
<!--                    </button>-->
<!--                </div>-->
            </div>
            <div class="mt-8 flex flex-col">
                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div
                        class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
                    >
                        <div
                            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                        >
                            <table class="min-w-full divide-y divide-gray-300">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                        >
                                            Name
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Category
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Status
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Public
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Featured
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Verified
                                        </th>

                                        <th
                                            scope="col"
                                            class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                                        >
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    class="divide-y divide-gray-200 bg-white"
                                >
                                    <tr
                                        v-for="business in props.businesses.data"
                                        :key="business.id"
                                    >
                                        <td
                                            class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                                        >
                                            <div class="flex items-center">
                                                <div
                                                    class="h-10 w-10 flex-shrink-0"
                                                >
                                                    <img
                                                        v-if="business.image"
                                                        class="h-10 w-10 rounded-full object-scale-down border-[1px] border-gray-300"
                                                        :src="business.image"
                                                        alt=""
                                                    />
                                                    <div
                                                        v-else
                                                        class="h-10 w-10 rounded-full inline-flex justify-center items-center font-normal text-base bg-[#ed1b24] text-white"
                                                    >
                                                        {{ business.initial }}
                                                    </div>
                                                </div>
                                                <div class="ml-4">
                                                    <div
                                                        class="font-medium text-gray-900"
                                                    >
                                                        {{ business.name }}
                                                    </div>
                                                    <div class="text-gray-500">
                                                        {{ business.email }} <br />{{ (business.phone) ? business.phone : '' }}
                                                    </div>
<!--                                                    <LocationMarkerIcon class="h-3 w-3" />-->
                                                    <span class="text-gray-500 text-[10px]">
                                                        {{ business.city }} {{ (business.region) ? ', ' + business.region : '' }}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <img
                                                class="h-10 w-10 rounded-full object-scale-down border-[1px] border-gray-300 ml-2"
                                                :src="'https://face-listings.s3.ca-central-1.amazonaws.com/markers/' + business.category.icon"
                                                alt=""
                                                :title="business.category.name"
                                            />
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <span
                                                v-if="business.status.active"
                                                class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800"
                                            >{{ business.status.label }}</span>
                                            <span
                                                v-if="!business.status.active"
                                                class="inline-flex rounded-full bg-gray-100 px-2 text-xs font-semibold leading-5 text-black"
                                            >{{ business.status.label }}</span>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <span
                                                v-if="business.visibility.public"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-green-500"
                                            >
                                                <CheckCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                            <span
                                                v-if="!business.visibility.public"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-red-500"
                                            >
                                                <XCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <span
                                                v-if="business.featured"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-green-500 ml-2"
                                            >
                                                <CheckCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                            <span
                                                v-if="!business.featured"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-red-500 ml-2"
                                            >
                                                <XCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <span
                                                v-if="business.verified"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-green-500 ml-1"
                                            >
                                                <CheckCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                            <span
                                                v-if="!business.verified"
                                                class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-red-500 ml-1"
                                            >
                                                <XCircleIcon class="h-6 w-6" aria-hidden="true" />
                                            </span>
                                        </td>
                                        <td
                                            class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                                        >
                                            <a
                                                href="#"
                                                class="text-indigo-600 hover:text-indigo-900"
                                                >Edit<span class="sr-only"
                                                    >, {{ business.name }}</span
                                                ></a
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <UserPagination
                                @next="next()"
                                @prev="prev()"
                                class="border-b border-gray-200 mb-4"
                                :navs="props.businesses.links"
                                :meta="props.businesses.meta"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script setup>
import Layout from "@/Shared/Layout";
import UserPagination from "@/Shared/UserPagination";
import { Inertia } from "@inertiajs/inertia";
import {reactive, ref, watch} from "vue";
import {useDebounceFn} from "@vueuse/core";
import { CheckCircleIcon, XCircleIcon, LocationMarkerIcon } from '@heroicons/vue/solid';
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import {assign, isEmpty, mapValues} from "radash";

const next = () => {
    Inertia.visit(props.businesses.links.next);
};

const prev = () => {
    Inertia.visit(props.businesses.links.prev);
};

const props = defineProps({
    businesses: Array,
    categories: Array
});

const cities = ref([]);
const regions = ref([]);
const addFilterSelect = ref("");

const filters = reactive({
    'region': false,
    'city': false,
    'email': false,
    'name': false,
    'verified': false,
    'featured': false,
    'publish': false,
    'category': false,
    'status': false
})

const fields = reactive({
    'region': '',
    'city': '',
    'email': '',
    'name': '',
    'verified': '',
    'featured': '',
    'publish': '',
    'category': '',
    'status': ''
});

watch(addFilterSelect, (filter) => {

    if (filter !== '') {
        filters[filter] = true
    }

    if(filter === 'city') {
        handleCitySearch();
    }

    if(filter === 'region') {
        handleRegionSearch();
    }

    addFilterSelect.value = "";
});

const removeFilter = (filter) => {
    if (!isEmpty(filter)) {
        filters[filter] = false;
        fields[filter] = false;
    }

    handleFilter();
}

const resetAllFilters = () => {
    mapValues(filters, () => null);
    mapValues(fields, () => '');
    handleFilter();
}

const handleFilter = useDebounceFn( async () => {
    try {
        const response = await axios.post(`/businesses/filter/`, fields);
        props.businesses.data = response.data.data;
        props.businesses.meta = response.data.meta;
    } catch (error) {
        console.log(error);
    }
}, 300);

const handleCitySearch = useDebounceFn( async () => {
    try {
        const {data} = await axios.get(`/api/cities?query=${fields.city}`);
        cities.value = data;
    } catch (error) {
        console.log(error);
    }
}, 300);

const handleRegionSearch = useDebounceFn( async () => {
    try {
        const {data} = await axios.get(`/api/regions?query=${fields.region}`);
        regions.value = data;
    } catch (error) {
        console.log(error);
    }
}, 300);

</script>
